<template>
	<div>
		<v-content>
			<v-container fluid>        
              <v-flex xs3>
                <v-text-field append-icon="search" v-if="search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                <v-text-field append-icon="search" v-if="search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>
				<v-data-table :headers="headers" :search="search" id="hello" :items="factoryList" hide-actions class="elevation-1" disable-initial-sort :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">						
						<td width="20%" class="text-xs-right">{{ props.item.name }}</td>      
						<td width="30%" class="text-xs-right">{{ props.item.description }}</td>
						<td width="30%" class="text-xs-right">{{ props.item.address }}</td>						
						<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncEditFactory(props.item.id)"><i class="material-icons">edit</i></a></td>						
						<td width="10%" class="text-xs-right" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1"><a @click.prevent="fncDeleteFactory(props.item.id)"><i class="material-icons">delete_forever</i></a></td>						
					</template>
				</v-data-table>
			</v-container>
		</v-content>		
	</div>
</template>

<script>
	
  import { mapGetters } from 'vuex';  

  export default {
	name: 'StatusList',
	intRoleEdit: 0,
    data () {
		return {	
			search: '',
			headers: [         
				{ text: 'Name', value: 'name', width: '20%' },
                { text: 'Description', value: 'description', width: '30%' },
                { text: 'Address', value: 'address', width: '30%' },
                { text: 'Edit', value: 'edit', width: '10%' },
                { text: 'Delete', value: 'delete', width: '10%' }		
			]
		}
	},
	methods: {
		fncEditFactory( factoryId ) {		
			this.$store.commit({
				type: 'setObjFactoryEdit',
                id: factoryId
			});
            var modalDetails = { title: 'Edit Factory', component: 'modal-factory-edit', mstate: true, params: { factoryId: factoryId} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
        fncDeleteFactory(factoryId ) {
			var deleteConfirm = confirm('Are you sure you want to remove this factory?');
			if(deleteConfirm === true) {
				this.$store.dispatch({
					type: 'fncDeleteFactory',
                    factoryId: factoryId
				})
			}
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'factoryList',
			'globalModalParams'
		])
	},
	beforeMount() {
        this.$store.dispatch('fncPopulateFactories');		
	},
	created() {		
	}
}	
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>